import { message as antdMessage } from 'antd';
export class message {
  static success(content) {
    antdMessage.success({ content: content });
  }

  static error(content) {
    antdMessage.error({ content: content });
  }
}
